/**** cat.DevGsm */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'cat',
  table: 'DevGSM',
  title: 'GSM-модемы',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    vehicle: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Vehicle',
      index: 'vehicle_id',
      fields: ['depot_number'],
      format: (elem: any) => elem['depot_number'],
      autocomplete: true
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'name',
      title: 'Наименование',
      type: 'text',
      required: true,
    },
    {
      name: 'ModuleEnabled',
      title: 'Состояние',
      type: 'list',
      required: true,
      values: [
        { key: null, value: '' },
        { key: 1, value: 'Включен' },
        { key: 0, value: 'Отключен' },
      ],
    },
    {
      name: 'vehicle_id',
      title: 'Транспортное средство',
      type: 'number',
      required: true,
      connection: 'vehicle',
    },
    {
      name: 'device_cmd',
      title: 'Адрес подключения управляющих команд',
      type: 'text',
      required: true,
    },
    {
      name: 'device_ppp',
      title: 'Адрес подключения интернет-соединений',
      type: 'text',
      required: true,
    },
  ],
  newTemplate: {
    id: null,
    name: '',
    ModuleEnabled: null,
    vehicle_id: null,
    device_cmd: '',
    device_ppp: '',
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'modem_id',
        field: 'id',
      },
      {
        title: 'modem_name',
        field: 'name',
      },
      {
        title: 'state',
        field: 'ModuleEnabled',
      },
      {
        title: 'vehicle_id',
        field: 'vehicle_id',
      },
      {
        title: 'control_commands_adress',
        field: 'device_cmd',
      },
      {
        title: 'connection_adress',
        field: 'device_ppp',
      },
    ],
    example: `1;Наименование GSM;1;1;;`,
  },
};

export default config;
